var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":_vm.width},model:{value:(_vm.internalDialog),callback:function ($$v) {_vm.internalDialog=$$v},expression:"internalDialog"}},[_c('v-alert',{staticStyle:{"margin-bottom":"0"},attrs:{"type":_vm.options.type}},[_vm._v(_vm._s(_vm.options.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }